var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66665 5.99967H7.33331V4.66634H8.66665M8.66665 11.333H7.33331V7.33301H8.66665M7.99998 1.33301C7.1245 1.33301 6.25759 1.50545 5.44876 1.84048C4.63992 2.17551 3.90499 2.66657 3.28593 3.28563C2.03569 4.53587 1.33331 6.23156 1.33331 7.99967C1.33331 9.76778 2.03569 11.4635 3.28593 12.7137C3.90499 13.3328 4.63992 13.8238 5.44876 14.1589C6.25759 14.4939 7.1245 14.6663 7.99998 14.6663C9.76809 14.6663 11.4638 13.964 12.714 12.7137C13.9643 11.4635 14.6666 9.76778 14.6666 7.99967C14.6666 7.1242 14.4942 6.25729 14.1592 5.44845C13.8241 4.63961 13.3331 3.90469 12.714 3.28563C12.095 2.66657 11.36 2.17551 10.5512 1.84048C9.74236 1.50545 8.87546 1.33301 7.99998 1.33301Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.0e878854c3bd14c22a5b570aaccef445.svg";
export { ForwardRef as ReactComponent };